<script lang="ts">
    import { _ } from "svelte-i18n"
    import { scrollTo, scrollToTop } from "svelte-scrollto"
    import { currentLang, location } from "../../store"
    import { getContent } from "../../api"

    import MainSlider from "../widgets/MainSlider.svelte"
    import CurrentProjectsSlider from "../widgets/CurrentProjectsSlider.svelte"
    import Header from "../widgets/Header.svelte"

    let loading = true
    let contents: Content[]
    let innerHeight: number
    let scrollY: number
    let lastScrollY: number = 0
    let onBottom: boolean = false

    const loadContent = async () => {
        let apiParams: APIParams = {
            filter: {
                public: true,
                locale: $currentLang,
                type: "project",
            },
        }

        loading = true
        const c = await getContent(apiParams)
        if (c) {
            contents = c
        }

        loading = false
    }

    loadContent()

    const scrollDirection = (scrollY) => {
        const d = lastScrollY <= scrollY ? "down" : "up"

        if ($location.path === "/") {
            // scrollY < innerHeight - 100
            if (d === "up" && scrollY < 300 && onBottom) {
                scrollToTop({
                    onDone: () => {
                        onBottom = false
                    },
                })
            } else if (d === "down" && scrollY > 0 && !onBottom) {
                scrollTo({
                    y: innerHeight + 60,
                    duration: 400,
                    offset: 0,
                    onDone: () => {
                        onBottom = true
                    },
                })
            }
        }

        lastScrollY = scrollY <= 0 ? 0 : scrollY
    }

    $: scrollDirection(scrollY)
</script>

<svelte:window bind:scrollY bind:innerHeight />

<Header />

{#if contents}
    <main class="page home">
        <MainSlider contents="{contents}" />
        <CurrentProjectsSlider contents="{contents}" />
    </main>
{/if}
